// src/components/ReviewsList.js

import React from 'react';
import { List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, Rating } from '@mui/material';
import PropTypes from 'prop-types';

const ReviewsList = ({ reviews }) => {
    if (reviews.length === 0) {
        return <Typography>No reviews yet.</Typography>;
    }

    return (
        <List>
            {reviews.map((review) => (
                <ListItem key={review.id} alignItems="flex-start">
                    <ListItemAvatar>
                        {/* Use the profile picture if available, otherwise fall back to the first letter of the first name */}
                        {review.reviewer_profile_picture ? (
                            <Avatar src={review.reviewer_profile_picture} />
                        ) : (
                            <Avatar>{(review.reviewer_first_name || '')[0]}</Avatar>
                        )}
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            <Typography component="span" variant="body1" color="text.primary">
                                {review.reviewer_first_name || ''} {review.reviewer_last_name || ''}
                            </Typography>
                        }
                        secondary={
                            <>
                                <Rating value={review.rating} readOnly size="small" />
                                <Typography component="span" variant="body2" color="text.primary">
                                    {` ${review.comment}`}
                                </Typography>
                            </>
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};

ReviewsList.propTypes = {
    reviews: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            reviewer_first_name: PropTypes.string,
            reviewer_last_name: PropTypes.string,
            rating: PropTypes.number.isRequired,
            comment: PropTypes.string,
        })
    ).isRequired,
};

export default ReviewsList;
